import { render } from "./NewSubArea.vue?vue&type=template&id=62ad3904&scoped=true"
import script from "./NewSubArea.vue?vue&type=script&lang=js"
export * from "./NewSubArea.vue?vue&type=script&lang=js"

import "./NewSubArea.vue?vue&type=style&index=0&id=62ad3904&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ad3904"]])

export default __exports__